<div class="iban-input-container" [formGroup]="form">
  <input
    placeholder="IBAN"
    type="text"
    [name]="name()"
    [formControlName]="controlName()"
    [mask]="mask"
    [inputTransformFn]="inputTransformFn"
    [outputTransformFn]="outputTransformFn"
    [class.error]="errorMessage()"
  />
  @if (errorMessage(); as _message) {
    <span class="error-message">{{ _message }}</span>
  }
</div>
